export default function AvatarGroup({count = 0}) {
  return (
    <>
      <div className="flex -space-x-7 overflow-hidden">
        {count < 6
          ? [...new Array(count)].map((_, i) => (
              <img
                className="inline-block h-14 w-14 rounded-full ring-2 ring-white"
                src="https://images.unsplash.com/photo-1500648767791-00dcc994a43e?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2.25&w=256&h=256&q=80"
                alt=""
                key={i}
              />
            ))
          : new Array(5).fill('').map((_, i) => (
              <div key={i}>
                <img
                  className="inline-block h-14 w-14 rounded-full ring-2 ring-white"
                  src="https://images.unsplash.com/photo-1500648767791-00dcc994a43e?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2.25&w=256&h=256&q=80"
                  alt=""
                />
              </div>
            ))}

        {count > 5 && (
          <div className="flex h-14 w-14 flex-col justify-center rounded-full bg-[#BAF639] text-center text-[16px] font-bold">
            {count - 5}+
          </div>
        )}
      </div>
    </>
  );
}
